import React from "react"
import {PriceWrapperItem, StandardDeliveryContainer, TotalValue, StandardDeliveryText, TotalText} from "./component"
import {StyledActionsContainer} from "../../component"

export type ClubPriceAndDeliveryInfoProps = {
    isFirstSection: boolean
    totalText: string
    finalOrderValueFormatted: string
    description: string
}

export const ClubPriceAndDeliveryInfo = ({
    isFirstSection,
    totalText,
    finalOrderValueFormatted,
    description,
}: ClubPriceAndDeliveryInfoProps) => {
    return (
        <StyledActionsContainer isFirstSection={isFirstSection}>
            <PriceWrapperItem>
                <TotalText>{totalText}</TotalText>
                <TotalValue data-testid="header-mini-shopping-bag-total">{finalOrderValueFormatted}</TotalValue>
            </PriceWrapperItem>
            <StandardDeliveryContainer>
                <StandardDeliveryText>{description}</StandardDeliveryText>
            </StandardDeliveryContainer>
        </StyledActionsContainer>
    )
}

export default ClubPriceAndDeliveryInfo
